var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHellip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M4.3 1.9a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0m7.6 0a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0m5.7 1.9a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8",
  clipRule: "evenodd"
})));
export default SvgHellip;